import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

type Props = {
  clientId: number;
  locationName: string;
};

function useGetLocationDetail({ clientId, locationName }: Props) {
  const { client: clientApi } = useApiContext();
  const { showApiError } = useGlobalContext();
  const { t } = useTranslation('global');

  const { data, isLoading, isSuccess } = useQuery(
    [KEYS.client.clients.locationDetail(clientId, locationName)],
    () => clientApi.clients.locationDetail(clientId, locationName),
    {
      select: (response) => response.data.data,
      onError: (error) => showApiError(error, t('errorMessages.localization')),
      enabled: !!clientId && !!locationName,
      refetchOnWindowFocus: false
    }
  );

  return {
    location: data,
    locationIsLoading: isLoading,
    locationIsSuccess: isSuccess
  };
}

export default useGetLocationDetail;
